/* eslint-disable react/prop-types */
import {
  Modal,
  PrimaryButton,
  TextButton,
  Input,
  InputCuitCuil,
  InputDropdown,
  InputDate,
  InputMoney,
} from '@artprov/design-system'
import { useEffect, useState } from 'react'
import {
  nombreValidation,
  documentoValidation,
  tipoDocValidation,
  cuilValidation,
  sexoValidation,
  fechaNacimientoValidation,
  sueldoValidation,
  cantDiasTrabajadosValidation,
} from '../../schema/detalleNominaValidations'
import { tiposDocumento } from '../../tiposDocumento'

export default function ModalCorreccionErrorItem({
  openModal,
  onCloseModal,
  mensaje = 'Mensaje en el inputTextArea',
  subtitulo = 'subtitulo',
  titulo = 'Titulo del modal',
  hintsInputMonth = [{}],
  onAcceptModal,
  disabledBtnAceptar = true,
  onRedirectToCargarNomina,
  itemDetalleNomina = {},
  periodo,
}) {
  const [idDetalleNomina, setIdDetalleNomina] = useState(0)
  const [idNomina, setIdNomina] = useState(0)
  const [originalValues, setOriginalValues] = useState({})
  const [modifiedValues, setModifiedValues] = useState({})

  const [nroDoc, setNroDoc] = useState('')
  const [hintsNroDoc, setHintsNroDoc] = useState([])

  const [tipoDoc, setTipoDoc] = useState('')
  const [valueTipoDoc, setValueTipoDoc] = useState('')
  const [hintsTipoDoc, setHintsTipoDoc] = useState([])

  const [cuil, setCuil] = useState('')
  // const [hintsCuil, setHintsCuil] = useState([])
  const [hintsCuil, setHintsCuil] = useState([{ variant: 'default', text: 'Ingrese CUIT/CUIL' }])

  const [nombre, setNombre] = useState('')
  const [hintsNombre, setHintsNombre] = useState([])

  const [sexo, setSexo] = useState('')
  const [hintsSexo, setHintsSexo] = useState([])

  const [cantDiasTrabajados, setCantDiasTrabajados] = useState('')
  const [hintsCantDiasTrabajados, setHintsCantDiasTrabajados] = useState([])

  const [fecNac, setFecNac] = useState('')
  const [hintsFecNac, setHintsfecNac] = useState([])

  const [sueldo, setSueldo] = useState('')
  const [hintsSueldo, setHintsSueldo] = useState([])

  const normalizarValor = (key, value) => {
    if (value == null) return ''

    let val = String(value).trim()

    switch (key) {
      case 'cuil':
        // eliminar guiones
        return val.replace(/-/g, '')
      case 'sueldo':
        // eliminar $, puntos, espacios y convertir coma decimal a punto
        return val.replace(/[\$.\s]/g, '').replace(',', '.')
      default:
        return val
    }
  }

  const getDifferences = (a, b) => {
    const diffs = {}

    Object.keys(a).forEach((key) => {
      const valA = normalizarValor(key, a[key])
      const valB = normalizarValor(key, b[key])

      if (valA !== valB) {
        diffs[key] = { oldValue: a[key], newValue: b[key] }
      }
    })

    return diffs
  }

  const setters = {
    documento: setNroDoc,
    tipoDoc: setTipoDoc,
    cuil: setCuil,
    nombre: setNombre,
    sexo: setSexo,
    cantDiasTrabajados: setCantDiasTrabajados,
    fechaNacimiento: setFecNac,
    sueldo: setSueldo,
  }

  const hintSetters = {
    documento: setHintsNroDoc,
    tipoDoc: setHintsTipoDoc,
    cuil: setHintsCuil,
    nombre: setHintsNombre,
    sexo: setHintsSexo,
    cantDiasTrabajados: setHintsCantDiasTrabajados,
    fechaNacimiento: setHintsfecNac,
    sueldo: setHintsSueldo,
  }

  const inputValidation = {
    documento: documentoValidation,
    tipoDoc: tipoDocValidation,
    cuil: cuilValidation,
    nombre: nombreValidation,
    sexo: sexoValidation,
    cantDiasTrabajados: cantDiasTrabajadosValidation(periodo),
    fechaNacimiento: fechaNacimientoValidation,
    sueldo: sueldoValidation,
  }

  const validateInputs = () => {
    let hasError = false
    Object.entries(modifiedValues).forEach(([key, value]) => {
      const hintSetter = hintSetters[key]
      const validation = inputValidation[key]
      const schema = typeof validation === 'function' ? validation() : validation

      const { error } = schema.validate(value)
      // const result = validation().validate(value)
      // const errores = result?.error?.details

      const errores = error?.details

      if (errores?.length) {
        if (hintSetter) hintSetter([{ variant: 'error', text: errores[0].message }])
        hasError = true
      } else {
        if (hintSetter) hintSetter([])
      }
    })

    if (!hasError) {
      persistChanges()
    }
  }

  const handleErrorAfterSubmit = (response) => {
    const errors = response?.response?.data?.message
    errors?.forEach((err) => {
      const { key, message } = err
      const hintSetter = hintSetters[key]
      if (hintSetter) hintSetter([{ variant: 'error', text: message }])
    })
  }
  const persistChanges = async () => {
    let data = getDifferences(originalValues, modifiedValues)
    if (Object.keys(data).length) {
      const dtoItem = Object.fromEntries(Object.entries(data).map(([key, obj]) => [key, obj.newValue]))
      const dto = { idNomina: idNomina, idDetalleNomina: idDetalleNomina, dtoItemDetalle: dtoItem }
      const response = await onAcceptModal(dto)
      handleErrorAfterSubmit(response)
    }
  }

  const handleSetDataWithErrors = (itemRaw) => {
    const item = {
      documento: itemRaw?.nro_doc,
      tipoDoc: itemRaw?.tip_doc,
      cuil: itemRaw?.cuil,
      nombre: itemRaw?.nombre,
      sexo: itemRaw?.sexo,
      cantDiasTrabajados: itemRaw?.cant_dias_trabajados,
      fechaNacimiento: itemRaw?.fec_nac,
      sueldo: itemRaw?.sueldo,
    }

    const erroresRaw = itemRaw.erroresRaw.errores
    const erroresPorCampo = Object.fromEntries(erroresRaw.map((e) => [e.columnaNombreIdentificatorio, e.errores]))

    // Recorrer todas las keys de itemRaw
    Object.entries(item).forEach(([key, value]) => {
      const setter = setters[key]
      const hintSetter = hintSetters[key]
      const errores = erroresPorCampo[key] || []

      if (!setter) return

      if (errores.length) {
        if (hintSetter) hintSetter([{ variant: 'error', text: errores[0] }])
      } else {
        setter(value)

        if (hintSetter) hintSetter([])
      }
    })
  }

  const handleChange = (field, value) => {
    setModifiedValues((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  // Formatea el número de documento con separador de miles (puntos)
  const formatNroDoc = (value) => {
    if (!value) return ''
    // eliminar puntos existentes para evitar doble formateo
    const clean = String(value).replace(/\./g, '')
    // agregar punto cada 3 dígitos desde la derecha
    return clean.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  // Valor formateado para mostrar en el input
  const formattedNroDoc = formatNroDoc(nroDoc)

  const getOpcionesTipoDoc = () => {
    return tiposDocumento
  }

  const getTipoDocToDom = () => {
    let opciones = []
    const tipoDocsOptions = getOpcionesTipoDoc()
    for (const item of tipoDocsOptions) {
      opciones.push(
        <InputDropdown.Option id={item.id} value={item.valueToShow}>
          {item.valueToShow}
        </InputDropdown.Option>
      )
    }

    return opciones
  }

  const handleOnChangeTipoDoc = (event) => {
    const tipoDocsOptions = getOpcionesTipoDoc()
    if (event.value) {
      let e = tipoDocsOptions.filter((el) => {
        return el.valueToShow == event.value
      })[0]
      setTipoDoc(e.id)
      setValueTipoDoc(e.valueToShow)
      handleChange('tipoDoc', e.id)
    }
  }

  useEffect(() => {
    const tipoDocsOptions = getOpcionesTipoDoc()
    if (tipoDoc != '') {
      let e = tipoDocsOptions.filter((el) => {
        return el.id == tipoDoc
      })[0]
      setTipoDoc(e?.id)
      setValueTipoDoc(e?.valueToShow)
      handleChange('tipoDoc', e?.id)
    }
  }, [tipoDoc])

  useEffect(() => {
    const initialValues = {
      documento: itemDetalleNomina?.nro_doc,
      tipoDoc: itemDetalleNomina?.tip_doc,
      cuil: itemDetalleNomina?.cuil,
      nombre: itemDetalleNomina?.nombre,
      sexo: itemDetalleNomina?.sexo,
      cantDiasTrabajados: itemDetalleNomina?.cant_dias_trabajados,
      fechaNacimiento: itemDetalleNomina?.fec_nac,
      sueldo: itemDetalleNomina?.sueldo,
    }

    setOriginalValues(initialValues)
    setModifiedValues(initialValues)
    setIdDetalleNomina(itemDetalleNomina.id)
    setIdNomina(itemDetalleNomina.id_nomina)
    handleSetDataWithErrors(itemDetalleNomina)
    // debugErrorItem(itemDetalleNomina)
  }, [itemDetalleNomina, periodo])

  return (
    <Modal.Container open={openModal} onClose={onCloseModal} closeOnClickOutside={false}>
      <Modal.Content width={680} height="auto">
        <Modal.Header>
          <Modal.Title className="pl-2">{titulo}</Modal.Title>
          <Modal.Close onClose={() => onCloseModal()} />
        </Modal.Header>
        <Modal.Body>
          <div className="modal-content bg-tertiary-100 w-[600px]">
            <div className="grid grid-cols-12 gap-4 mb-3 ">
              <div className="col-span-6">
                <InputDropdown
                  defaultSelection={false}
                  key={`tipDoc-${itemDetalleNomina.id}`}
                  label="Tipo de documento"
                  status={hintsTipoDoc.length ? 'error' : 'default'}
                  hints={hintsTipoDoc}
                  placeholder="Seleccionar"
                  value={valueTipoDoc}
                  onChange={(event) => {
                    handleOnChangeTipoDoc(event)
                  }}
                >
                  {getTipoDocToDom()}
                </InputDropdown>
              </div>
              <div className="col-span-6">
                <Input
                  className="min-w-[200px]"
                  type="text"
                  label="N° de documento"
                  placeholder="20.123.456"
                  maxCharacters={11} // includes dots
                  disabled={false}
                  value={formattedNroDoc}
                  status={hintsNroDoc.length ? 'error' : 'default'}
                  hints={hintsNroDoc}
                  onChange={(e) => {
                    // remove thousand separators before storing raw value
                    const raw = e.replace(/\./g, '')
                    setNroDoc(raw)
                    handleChange('documento', raw)
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4  ">
              <div className="col-span-6">
                <InputCuitCuil
                  label="CUIL"
                  name="cuil"
                  id="cuil"
                  placeholder="20-20123456-X"
                  value={cuil}
                  disabled={false}
                  status={hintsCuil.length ? 'error' : 'default'}
                  hints={hintsCuil}
                  onValidate={(e) => {
                    if (e) {
                      setHintsCuil([])
                    }
                  }}
                  onChange={(event) => {
                    handleChange('cuil', event)
                  }}
                  autoComplete="off"
                />
              </div>
              <div className="col-span-6">
                <Input
                  type="text"
                  label="Apellido y Nombre"
                  status={hintsNombre.length ? 'error' : 'default'}
                  hints={hintsNombre}
                  placeholder="Rodriguez Juan"
                  disabled={false}
                  value={nombre}
                  onChange={(e) => {
                    if (e) {
                      handleChange('nombre', e)
                    }
                  }}
                />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 mb-4 mt-4 ">
              <div className="col-span-6">
                <InputDropdown
                  defaultSelection={false}
                  key={`sexo-${itemDetalleNomina.id}`}
                  label="Sexo"
                  placeholder="Seleccionar"
                  status={hintsSexo.length ? 'error' : 'default'}
                  hints={hintsSexo}
                  value={sexo}
                  onChange={(e) => {
                    // setSexo(e.value)
                    handleChange('sexo', e.value)
                  }}
                >
                  <InputDropdown.Option id={'M'} value={'M'}>
                    M
                  </InputDropdown.Option>
                  <InputDropdown.Option id={'F'} value={'F'}>
                    F
                  </InputDropdown.Option>
                  <InputDropdown.Option id={'X'} value={'X'}>
                    X
                  </InputDropdown.Option>
                </InputDropdown>
              </div>
              <div className="col-span-6">
                {' '}
                <InputDate
                  label="Fecha de Nacimiento"
                  name="fecNac"
                  calendar={false}
                  value={fecNac}
                  onChange={(e) => {
                    handleChange('fechaNacimiento', e)
                  }}
                  hints={hintsFecNac}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 mb-4 mt-4 ">
              <div className="col-span-6">
                <Input
                  type="number"
                  label="Cantidad de días trabajados"
                  placeholder="30"
                  disabled={false}
                  status={hintsCantDiasTrabajados.length ? 'error' : 'default'}
                  hints={hintsCantDiasTrabajados}
                  value={cantDiasTrabajados}
                  onChange={(e) => {
                    handleChange('cantDiasTrabajados', e)
                  }}
                />
              </div>
              <div className="col-span-6">
                <InputMoney
                  label="Sueldo"
                  name="sueldo"
                  id="sueldo"
                  disabled={false}
                  onChange={(e) => {
                    handleChange('sueldo', e)
                  }}
                  status={hintsSueldo.length ? 'error' : 'default'}
                  hints={hintsSueldo}
                  value={sueldo}
                  className="px-1"
                  autoComplete="off"
                  maxCharacters={12}
                />
              </div>
            </div>
          </div>
          {/* </Container> */}
        </Modal.Body>
        <Modal.Footer>
          <TextButton
            size="medium"
            className="mr-1"
            onClick={() => {
              onCloseModal()
            }}
          >
            Cancelar
          </TextButton>
          <PrimaryButton
            disabled={false}
            className="mx-2"
            size="small"
            onClick={() => {
              validateInputs()
            }}
            classNameIcon="text-tertiary-100"
          >
            Confirmar cambios
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  )
}
